import React from 'react';
import { Letterhead } from './components/sections/Letterhead';
import { Situation } from './components/sections/Situation';
import { Product } from './components/sections/Product';
import { Scope } from './components/sections/Scope';
import { Investment } from './components/sections/Investment';
import { company, offer } from './data/offer';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="2rkx4ngpoehnj">
      <Letterhead data-id="element-1" data-mp="2risyes4b16k3" />
      <main data-id="element-2" data-mp="2mlu68f47b9oj">
        <Situation data-id="element-3" data-mp="2mmccm4kkv4a6" />
        <Product data-id="element-4" data-mp="2mmvk0rclqa9y" />
        <Scope data-id="element-5" data-mp="2mndqshww46w4" />
        <Investment data-id="element-6" data-mp="2mjpwhgjmfggc" />
      </main>
      <footer data-id="element-7" data-mp="31agq8u4rwpm3">
        <div className="mx-auto flex max-w-5xl flex-col gap-2 px-8 py-10 text-xs text-white/40 md:flex-row md:items-center md:justify-between md:px-12" data-id="element-8" data-mp="31ayplzmqfjy8">
          <p data-id="element-9" data-mp="2wi5mthatqlos">
            {company.name} · {company.address}
          </p>
          <p data-id="element-10" data-mp="28suv0pbgc1ms">
            Offerte {offer.subject.toLowerCase()} · {offer.date} · geldig t/m{' '}
            {offer.validUntil}
          </p>
          <a href={company.siteHref} target="_blank" rel="noreferrer" className="text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-11" data-mp="3ik7gwiph6frp">
            {company.site}
          </a>
        </div>
      </footer>
    </div>;
}